export const args = {
    title: 'Repayment',
    message: 'Outstanding amount',
    amount: '5,000',
    btnText: 'Flexi Pay',
    warning: 'Upcoming auto debit of ₹400 on 25th Oct',
};
export const argTypes = {
    onPress: { action: 'clicked' },
};
